import React from 'react';
import { Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();

  const getPrivacyPolicyUrl = () => {
    if (i18n.language === 'en') {
      return 'https://www.visit.brussels/en/visitors/about-us/privacy-policy';
    }
    if (i18n.language === 'nl') {
      return 'https://www.visit.brussels/nl/bezoekers/over-ons/privacy-policy';
    }
    return 'https://www.visit.brussels/fr/visiteurs/a-propos/charte-de-vie-privee';
  };

  const getCookiePolicyUrl = () => {
    if (i18n.language === 'en') {
      return 'https://www.visit.brussels/en/visitors/about-us/cookies-policy';
    }
    if (i18n.language === 'nl') {
      return 'https://www.visit.brussels/nl/bezoekers/over-ons/gebriuk-van-cookies';
    }
    return 'https://www.visit.brussels/fr/visiteurs/a-propos/cookies';
  };

  const getGeneralTermsUrl = () => {
    if (i18n.language === 'en') {
      return 'https://www.visit.brussels/en/visitors/about-us/general-terms-and-conditions-of-use-of-the-website';
    }
    if (i18n.language === 'nl') {
      return 'https://www.visit.brussels/nl/bezoekers/over-ons/algemene-gebruiksvoorwaarden-voor-het-gebruik-van-de-website';
    }
    return 'https://www.visit.brussels/fr/visiteurs/a-propos/conditions-generales-d-utilisation-du-site-internet';
  };

  const getFaqUrl = () => {
    if (i18n.language === 'en') {
      return 'https://www.visit.brussels/en/professionals/partners/faq-partners/faq-adding-an-event';
    }
    if (i18n.language === 'nl') {
      return 'https://www.visit.brussels/nl/professionals/partners/faq-partners/faq-een-evenement-invoeren';
    }
    return 'https://www.visit.brussels/fr/professionnels/partners/faq-partenaires/faq-ajouter-un-evenement-dans-notre-agenda';
  };

  return (
    <footer className="footer mt-auto">
      <div className="container-fluid">
        <div className="row py-3 bg-dark text-white">
          <div className="col">
            <div className="container">
              &copy; {new Date().getFullYear()} Visit Brussels. All rights
              reserved.
              <a
                href={getPrivacyPolicyUrl()}
                aria-label={t('general.privacyPolicy')}
              >
                {' '}
                {t('general.privacyPolicy')}
              </a>
              <a
                href={getCookiePolicyUrl()}
                aria-label={t('general.cookiePolicy')}
              >
                {' '}
                {t('general.cookiePolicy')}
              </a>
              <a
                href={getGeneralTermsUrl()}
                aria-label={t('general.generalTermsConditions')}
              >
                {' '}
                {t('general.generalTermsConditions')}
              </a>
              <a
                href={getFaqUrl()}
                aria-label={t('general.frequentlyAskedQuestions')}
              >
                {' '}
                FAQ
              </a>
            </div>
          </div>
        </div>
        <div className="row py-3">
          <div className="column text-center w-100">
            <div className="container">
              <div className="h5 mb-3">{t('general.withSupportOf')}</div>
              <div className="d-flex flex-wrap justify-content-around">
                <Image
                  alt={t('general.vgcLogoAlt')}
                  height="100"
                  src="/img/logo-n-brussel.png"
                />
                <Image
                  alt={t('general.cocofLogoAlt')}
                  height="100"
                  src="/img/logo-francophones.png"
                />
                <Image
                  alt={t('general.brusselsCapitalRegionLogoAlt')}
                  height="100"
                  src="/img/logo-region-de-bruxelles.png"
                />
                <Image
                  alt={t('general.vlaanderenLogoAlt')}
                  height="100"
                  src="/img/logo-vlaanderen.png"
                />
                <Image
                  alt={t('general.fwbLogoAlt')}
                  height="100"
                  src="/img/logo-walonie-brussels.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
